import {
    transformCustomerPrices,
    transformFeatures,
    transformModules,
} from "../components/pages/fgModules/utils/dataTransformer";
import Config from "../Config";
import { authHeaderLicman } from "../helpers/requestHelpers";
import { actions } from "../reducers/fgModuleReducer";

const config = new Config();

/* Module Actions */
export const getModules = () => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "GET",
        headers: authHeaderLicman(),
    };
    try {
        const response = await fetch(config.apiUrl + `/${config.coreModule}/getModules`, requestOptions);
        const modulesFromApi = await response.json();
        const transformedData = transformModules(modulesFromApi);
        dispatch(actions.modulesReceived(transformedData));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const createModule = (moduleData) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(moduleData),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/createModule`, requestOptions);
        dispatch(getModules());
        dispatch(actions.genericSuccess("Modul erfolgreich erstellt!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const updateModule = (moduleData) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "PUT",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(moduleData),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/updateModule`, requestOptions);
        dispatch(getModules());
        dispatch(actions.genericSuccess("Modul erfolgreich aktualisiert!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const deleteModule = (moduleId) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "DELETE",
        headers: authHeaderLicman(),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/deleteModule/${moduleId}`, requestOptions);
        dispatch(getModules());
        dispatch(actions.genericSuccess("Modul erfolgreich gelöscht!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

/* Version Actions */
export const createModuleVersion = (moduleId, versionData) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(versionData),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/createModuleVersion/${moduleId}`, requestOptions);
        dispatch(getModules());
        dispatch(actions.genericSuccess("Version erfolgreich hinzugefügt!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const updateModuleVersion = (versionData) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "PUT",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(versionData),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/updateModuleVersion`, requestOptions);
        dispatch(getModules());
        dispatch(actions.genericSuccess("Modulversion erfolgreich aktualisiert!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const deleteModuleVersion = (moduleVersionId) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "DELETE",
        headers: authHeaderLicman(),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/deleteModuleVersion/${moduleVersionId}`, requestOptions);
        dispatch(getModules());
        dispatch(actions.genericSuccess("Modulversion erfolgreich gelöscht!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

/* Feature Actions */
export const getFeatures = () => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "GET",
        headers: authHeaderLicman(),
    };
    try {
        const response = await fetch(config.apiUrl + `/${config.coreModule}/getFeatures`, requestOptions);
        const featuresFromApi = await response.json();
        const transformedData = transformFeatures(featuresFromApi);
        dispatch(actions.featuresReceived(transformedData));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const createFeature = (featureData) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(featureData),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/createFeature`, requestOptions);
        dispatch(getFeatures());
        dispatch(actions.genericSuccess("Feature erfolgreich erstellt!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const updateFeature = (featureData) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "PUT",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(featureData),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/updateFeature`, requestOptions);
        dispatch(getFeatures());
        dispatch(getModules());
        dispatch(actions.genericSuccess("Feature erfolgreich aktualisiert!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const deleteFeature = (featureId) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "DELETE",
        headers: authHeaderLicman(),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/deleteFeature/${featureId}`, requestOptions);
        dispatch(getFeatures());
        dispatch(getModules());
        dispatch(actions.genericSuccess("Feature erfolgreich gelöscht!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

/* FeatureAssignment Actions */
export const assignFeature = (moduleVersionId, featureId) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify({ moduleVersionId, featureIds: [featureId] }),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/createModuleVersionFeatureAssignments`, requestOptions);
        dispatch(getModules());
        dispatch(actions.genericSuccess("Feature erfolgreich zugewiesen!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const removeFeature = (moduleVersionId, featureId) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "DELETE",
        headers: authHeaderLicman(),
    };
    try {
        await fetch(
            config.apiUrl +
                `/${config.coreModule}/deleteModuleVersionFeatureAssignment/${moduleVersionId}/${featureId}`,
            requestOptions
        );
        dispatch(getModules());
        dispatch(actions.genericSuccess("Feature-Zuweisung entfernt!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

/* Customer Price Actions */
export const getCustomerPrices = (moduleVersionId) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "GET",
        headers: authHeaderLicman(),
    };
    try {
        const response = await fetch(
            config.apiUrl + `/${config.coreModule}/getCustomerModuleVersionPrices/${moduleVersionId}`,
            requestOptions
        );
        const pricesFromApi = await response.json();
        const transformedPrices = transformCustomerPrices(pricesFromApi);
        dispatch(actions.customerPricesReceived({ versionId: moduleVersionId, prices: transformedPrices }));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const updateCustomerPrice = (licenseId, moduleVersionId, monthlyPrice) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify({ licenseId, moduleVersionId, monthlyPrice }),
    };
    try {
        await fetch(config.apiUrl + `/${config.coreModule}/setCustomerModuleVersionPrice`, requestOptions);
        dispatch(getCustomerPrices(moduleVersionId));
        dispatch(actions.genericSuccess("Kundenpreis aktualisiert!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};

export const deleteCustomerPrice = (licenseId, moduleVersionId) => async (dispatch) => {
    dispatch(actions.modulesLoading());
    const requestOptions = {
        method: "DELETE",
        headers: authHeaderLicman(),
    };
    try {
        await fetch(
            config.apiUrl + `/${config.coreModule}/deleteCustomerModuleVersionPrice/${licenseId}/${moduleVersionId}`,
            requestOptions
        );
        dispatch(getCustomerPrices(moduleVersionId));
        dispatch(actions.genericSuccess("Individueller Preis entfernt!"));
    } catch (error) {
        dispatch(actions.apiError(error.toString()));
    }
};
